import { gql } from '@apollo/client'

import {
  LANGUAGE_FRAGMENT,
  SIMPLE_USER_FRAGMENT,
} from '../../../common/graphql/fragments'

import { BRAND_DETAILS_FRAGMENT } from '../../../brand-curation-tasks/graphql/fragments'
import { MENU_TITLE_NODE_FRAGMENT } from '../../../menu-title/graphql/fragments'

import ALLERGEN_LABEL_LEGEND_FRAGMENT from './allergen-label-legend-fragment'
import DIET_LABEL_LEGEND_FRAGMENT from './diet-label-legend-fragment'

const MENU_CURATION_TASK_DETAILS_FRAGMENT = gql`
  fragment MenuCurationTaskDetailsFragment on MenuCurationTask {
    id
    taskStatus
    blockedReason
    curationDetailLevel
    awaitingStatus
    problemReason
    problemComment
    isDeleted
    isReopenedManually
    isUnknownWordsCurationDone
    isUnknownWordsQaDone
    isTierOneDone
    isCurationDone
    isQaDone
    isQcDone
    curatedUnknownWordCount
    qadUnknownWordCount
    totalUnknownWordCount
    updatedAt
    createdAt
    reopenedAt
    unknownWordsCuratedAt
    unknownWordsQadAt
    tierOneDoneAt
    curatedAt
    qadAt
    qcdAt
    tierOneCuratorAssignedAt
    unknownWordsCuratorAssignedAt
    unknownWordsQaAssignedAt
    curatorAssignedAt
    qaAssignedAt
    qcAssignedAt
    lastManualUpdateAt
    tags
    brandCurationTaskId
    latestTierOneDoneDishCount
    latestCuratedDishCount
    latestQadDishCount
    latestQcdDishCount
    latestCuratedUnknownWordCount
    latestQadUnknownWordCount
    isAvailableForTierOne
    isAvailableForUnknownWordsCuration
    isAvailableForUnknownWordsQa
    isAvailableForCuration
    isAvailableForQa
    isAvailableForQc
    scrapingReviewComment
    scrapingReviewerComment
    scrapingClarificationComment
    isScrapingReviewDone
    hasLockedDishes

    languages {
      isSuggestedByAi
      language {
        ...LanguageFragment
      }
    }

    dietLabelLegends {
      ...DietLabelLegendFragment
    }

    allergenLabelLegends {
      ...AllergenLabelLegendFragment
    }

    menu {
      id
      autoeatId
      originalMenuId
      status
      isPublished
      dishCount
      hasPendingAutoeatUpdates
      autoeatUpdateAppliedAt
      cuisineType {
        id
        name
      }
      brand {
        ...BrandDetailsFragment
      }
      menuTitles {
        ...MenuTitleNodeFragment
      }
      locationCount
      url
      isFake
      autoeatUpdatedAt
      fileKey
      scrapingType
      scrapingValidationMessages
    }

    reopenedBy {
      ...SimpleUserFragment
    }

    createdBy {
      ...SimpleUserFragment
    }

    updatedBy {
      ...SimpleUserFragment
    }

    tierOneDoneBy {
      ...SimpleUserFragment
    }

    curatedBy {
      ...SimpleUserFragment
    }

    qadBy {
      ...SimpleUserFragment
    }

    qcdBy {
      ...SimpleUserFragment
    }

    unknownWordsCuratedBy {
      ...SimpleUserFragment
    }

    unknownWordsQadBy {
      ...SimpleUserFragment
    }

    assignedTierOneCurator {
      ...SimpleUserFragment
    }

    assignedCurator {
      ...SimpleUserFragment
    }

    assignedQa {
      ...SimpleUserFragment
    }

    assignedUnknownWordsCurator {
      ...SimpleUserFragment
    }

    assignedUnknownWordsQa {
      ...SimpleUserFragment
    }

    assignedQc {
      ...SimpleUserFragment
    }

    assignedScrapingReviewerUser {
      ...SimpleUserFragment
    }

    lastManualUpdateBy {
      ...SimpleUserFragment
    }

    priorityTaskAllocations {
      id
      priorityTask {
        id
        name
        allocationType
        isDone
      }
      allocatedUser {
        ...SimpleUserFragment
      }
      allocatedRole
      allocatedDishCount
      isDone
    }
  }
  ${MENU_TITLE_NODE_FRAGMENT}
  ${SIMPLE_USER_FRAGMENT}
  ${BRAND_DETAILS_FRAGMENT}
  ${DIET_LABEL_LEGEND_FRAGMENT}
  ${ALLERGEN_LABEL_LEGEND_FRAGMENT}
  ${LANGUAGE_FRAGMENT}
`

export default MENU_CURATION_TASK_DETAILS_FRAGMENT
